<template>
  <teleport to="body">
    <div v-if="visible === true" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div class="bg-base-100 dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-lg mx-4" :dir="isRtl === true ? 'rtl' : 'ltr'">
        <h3 class="text-lg font-semibold mb-1">{{ t('agentCreate.knowledge.urlsModal.title', 'Specific links') }}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">{{ t('agentCreate.knowledge.urlsModal.hint', 'Add one URL per line.') }}</p>
        <textarea
          v-model="urlsText"
          rows="8"
          class="textarea textarea-bordered w-full font-mono text-sm"
          :placeholder="urlsPlaceholder"
        ></textarea>
        <div class="flex justify-end mt-6">
          <button type="button" class="btn" @click="onClose">{{ t('common.cancel', 'Cancel') }}</button>
          <button type="button" class="btn ml-2" :disabled="canConfirm === false" @click="onConfirm">{{ t('common.confirm', 'Confirm') }}</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'confirm']);

const { t, currentLanguage, availableLanguages } = useI18n();
const urlsText = ref('');

const urlsPlaceholder = computed(() => {
  return t('agentCreate.knowledge.urlsModal.placeholder', 'https://example.com/about\nhttps://example.com/pricing');
});

const isRtl = computed(() => {
  const language = availableLanguages.value.find((item) => item.code === currentLanguage.value);
  if (language === undefined || language === null) {
    return false;
  }
  return language.dir === 'rtl';
});

const canConfirm = computed(() => {
  return parseUrls(urlsText.value).length > 0;
});

function parseUrls(text) {
  if (typeof text !== 'string') {
    return [];
  }
  const lines = text.split('\n');
  const urls = [];
  let index = 0;
  while (index < lines.length) {
    const line = lines[index].trim();
    if (line.length > 0) {
      urls.push(line);
    }
    index = index + 1;
  }
  return urls;
}

watch(() => props.visible, (value) => {
  if (value === true) {
    urlsText.value = '';
  }
});

function onClose() {
  emit('close');
}

function onConfirm() {
  const urls = parseUrls(urlsText.value);
  if (urls.length === 0) {
    return;
  }
  emit('confirm', urls);
}
</script>
